import{isZeroValueString as n}from"../../utils/is-zero-value-string.mjs.js";function r(r){return"number"==typeof r?0===r:null===r||("none"===r||"0"===r||n(r))}export{r as isNone};
